import ContributionSessions from './ContributionSessionsContainer';

export default ContributionSessions;
